import { configureStore } from '@reduxjs/toolkit';
import localforage from 'localforage';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import thunk from 'redux-thunk';
import { MW_5_13_0 } from '@rsos/reduxDataStore/src/constants/migrationVersions';
import { audioNotificationsListener } from '@rsos/reduxDataStore/src/features/audioNotifications/audioNotificationMiddleware';
import { psapInfoListener } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoMiddleware';
import { displaySchemaApi } from '@rsos/reduxDataStore/src/features/displaySchema/displaySchemaApi';
import { getSuggestedAddressesApi } from '@rsos/reduxDataStore/src/features/gisSearch/helpers';
import { rsosApi } from '@rsos/reduxDataStore/src/features/rsosApi';
import rootReducer from './app/rootReducer';
import { transcriptFeedbackApi } from './components/JurisdictionView/EventPane/tabs/TranscriptTab/TranscriptFeedback/transcriptFeedbackApi';
import { transcriptionApi } from './components/JurisdictionView/EventPane/tabs/TranscriptTab/transcriptionSlice';
import { radiosApi } from './components/JurisdictionView/EventPane/tabs/radiosSlice';
import { rtkQueryErrorMiddleware } from './middleware/rtkQueryErrorMiddleware';

// redux-persist setup
const persistConfig = {
  key: 'emergency_data',
  version: MW_5_13_0,
  storage: localforage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    rsosApi.reducerPath,
    displaySchemaApi.reducerPath,
    'incidents',
    'rad',
    'medicalert',
    'spatialLayers',
    'emergencyCalls',
    'eventPane',
    'search',
    'gisServices',
    'axon',
    'eagleEye',
    'mapCard', // do not persist. not allowed to store axon data
    'schemas',
    'transcriptionApi',
    'transcriptFeedbackApi', // do not want to persist potential PII
    'transcriptions',
    'radiosApi',
    'radios',
    'gisSearch',
    'mapPopover',
    'clickToIdentify',
    'what3words',
    'appLauncher',
    'obliqueImagery',
    'geoSelection',
    'airAmbulance',
    'keywordSets',
    'keywordTiers',
    'mapMarkup',
    'layerOpacity',
  ],
};
const pReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: pReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      thunk,
      rtkQueryErrorMiddleware,
      rsosApi.middleware,
      displaySchemaApi.middleware,
      transcriptionApi.middleware,
      transcriptFeedbackApi.middleware,
      radiosApi.middleware,
      getSuggestedAddressesApi.middleware,
      audioNotificationsListener.middleware,
      psapInfoListener.middleware,
    ),
});

export const persistor = persistStore(store);
